export const TYPE_BOOLEAN = 'Boolean';
export const TYPE_CHECKBOX = 'CheckBox';
export const TYPE_DATE = 'Date';
export const TYPE_ENUMERATOR = 'Enumerator';
export const TYPE_ENUMERATOR_MAP = 'EnumeratorMap';
export const TYPE_COMPOSITE = 'Composite';
export const TYPE_LIST = 'List';
export const TYPE_MONOLIST = 'Monolist';
export const TYPE_NUMBER = 'Number';
export const TYPE_THREESTATE = 'ThreeState';
export const TYPE_TIMESTAMP = 'Timestamp';
export const TYPE_HYPERTEXT = 'Hypertext';
export const TYPE_LONGTEXT = 'Longtext';
export const TYPE_TEXT = 'Text';


export const MODE_ADD = 'add';
export const MODE_EDIT = 'edit';
export const MODE_EDIT_COMPOSITE = 'editComposite';
export const MODE_ADD_COMPOSITE = 'addComposite';
export const MODE_ADD_ATTRIBUTE_COMPOSITE = 'addAttributeComposite';
export const MODE_ADD_MONOLIST_ATTRIBUTE_COMPOSITE = 'addMonolistAttributeComposite';
export const MODE_ADD_SUB_ATTRIBUTE_MONOLIST_COMPOSITE = 'addSubAttributeMonolistComposite';
